import { Platform } from 'react-native';
import Constants from 'expo-constants';

// This is the server key because we use the plentiful web servers as a proxy
// So yes, we expose this key to the public but that's ok since the key
// is protected to only allow our servers IP addresses
const googlePlacesApiKey = 'AIzaSyBb8Ih34xVTTBD5eT4OYcGrRjQhrzxERFY';
const unrestrictedGooglePlacesApiKey = 'AIzaSyDQCQYlnm5sZKcEFyMw7G1iqd5UikS8d3c';
const sentryDsn = 'https://cc4bc50bfd5e4d619336905d375fe664@o566812.ingest.sentry.io/6591658';
const statsigSdkKey = 'client-7pEzSYVF5lWBtHJlwXvwM3RKGJRvBzr1kJy0VbFWBHR';
// Web-only Maps credentials. components/map/MapViewWeb.js is the sole consumer,
// which is why the browser calls Google directly here rather than proxying
// through the Plentiful servers the way googlePlacesApiKey does. Because the
// key ships to the browser, it is locked down by HTTP referrer instead — the
// console's 'Websites' application restriction, explicitly not an IP
// restriction — to *.plentiful.org, *.plentifulapp.com, and a set of localhost
// dev origins. All three environments share this single key, which is why
// development origins appear on a key production also uses. Native maps use a
// different key, set in app.json under android.config.googleMaps.apiKey.
// googleMapsMapId is a public map-style identifier, not a credential.
const googleMapsApiKey = 'AIzaSyDFqIpMynm0psPqBF2fG1HRKqGyC6Dy27s';
const googleMapsMapId = 'd751136bdcfcc185a80dd3a9';

const apiPath = '/api/3.0/';

// API_HOST normally overrides just the hostname of the local backend (http://<host>:1337).
// If it already includes a scheme (e.g. a deployed CDK/preview backend served over https on 443),
// use it as-is instead of forcing http + port 1337.
const buildDevApiUrl = (defaultHost) => {
  const host = process.env.API_HOST || defaultHost;
  return /^https?:\/\//.test(host)
    ? `${host.replace(/\/+$/, '')}${apiPath}`
    : `http://${host}:1337${apiPath}`;
};

const EnvConfig = {
  development: {
    environment: 'development',
    apiUrl: buildDevApiUrl('localhost'),
    consoleLog: true,
    debugLog: true,
    useSentry: false,
    sentryEnv: 'development',
    minSentryLogLevel: 'debug',
    googlePlacesApiKey: unrestrictedGooglePlacesApiKey,
    statsigSdkKey,
    statsigEnv: 'development',
    reportIssueUrl: 'https://l-test.plntfl.app/map-issue-dev?organization_id=',
    googleMapsApiKey,
    googleMapsMapId,
  },
  staging: {
    environment: 'staging',
    apiUrl: `https://staging.service.plntfl.net${apiPath}`,
    // Off in staging: with useSentry on, the logger's console.* calls get re-ingested by Sentry's
    // ConsoleLogs integration, duplicating each structured log as an unparsed auto.log.console entry.
    consoleLog: false,
    debugLog: false,
    sentryDsn,
    useSentry: true,
    sentryEnv: 'staging',
    minSentryLogLevel: 'debug',
    googlePlacesApiKey,
    statsigSdkKey,
    statsigEnv: 'staging',
    reportIssueUrl: 'https://l-test.plntfl.app/map-issue-dev?organization_id=',
    googleMapsApiKey,
    googleMapsMapId,
  },
  production: {
    environment: 'production',
    apiUrl: `https://pantry.plentifulapp.com${apiPath}`,
    consoleLog: false,
    debugLog: false,
    sentryDsn,
    useSentry: true,
    sentryEnv: 'production',
    minSentryLogLevel: 'warn',
    googlePlacesApiKey,
    statsigSdkKey,
    statsigEnv: 'production',
    reportIssueUrl: 'https://plntfl.app/map-issue?organization_id=',
    googleMapsApiKey,
    googleMapsMapId,
  },
};

// our environment constants are now defined in app.config.js
// which makes them available in Constants.expoConfig.extra
let APP_ENV = process.env.APP_ENV || 'development';
if (Constants.expoConfig && Constants.expoConfig.extra) {
  APP_ENV = Constants.expoConfig.extra.APP_ENV;
}

export let EnvVars = EnvConfig[APP_ENV];
switch (Platform.OS) {
  case 'android':
    if (__DEV__) {
      EnvVars.apiUrl = buildDevApiUrl('10.0.2.2');
    }
    break;
  case 'ios':
    if (__DEV__) {
      EnvVars.apiUrl = buildDevApiUrl('localhost');
    }
    break;
  case 'web': {
    // Build-time override: Expo inlines EXPO_PUBLIC_APP_ENV at export, letting the web e2e build
    // target staging even when served from localhost. Falls back to hostname sniffing.
    const override = process.env.EXPO_PUBLIC_APP_ENV;
    if (override && EnvConfig[override]) {
      EnvVars = EnvConfig[override];
      break;
    }
    const host = window.location.hostname;
    if (host === 'localhost') {
      EnvVars = EnvConfig.development;
    } else if (host === 'app-dev.plentifulapp.com') {
      EnvVars = EnvConfig.staging;
    } else if (host === 'dkfb53ie66z6p.cloudfront.net') {
      EnvVars = EnvConfig.staging;
    } else if (host === 'app-dev-rn.s3-website-us-east-1.amazonaws.com') {
      EnvVars = EnvConfig.staging;
    } else {
      EnvVars = EnvConfig.production;
    }
    break;
  }
}
